import React from 'react';
import { Modal, ModalBody, ModalFooter, Button } from 'reactstrap';

interface Props {
  isOpen: boolean;
  toggle: () => void;
  body: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  size?: 'sm' | 'lg' | 'xl';
}

const GlobalModal: React.FC<Props> = ({ isOpen, toggle, body, footer, className, size = 'lg' }) => {
  return (
    <Modal className={className} isOpen={isOpen} toggle={toggle} size={size}>
      <ModalBody>{body}</ModalBody>
      {footer && <ModalFooter>{footer}</ModalFooter>}
    </Modal>
  );
};

export default GlobalModal;
